import { AstraCallout, AstraParagraph } from '~/astra'
import { useStore } from '~/store/store'

export const PrivacyModeBanner = () => {
    const togglePrivacyMode = useStore(state => state.app.actions.togglePrivacyMode)

    return (
        <AstraCallout
            color="caution"
            text={<AstraParagraph>All personlig identifiserbar pasientinformasjon er skjult. Ønsker du å vise det igjen? </AstraParagraph>}
            action={{ label: 'Vis persondata', onClick: () => togglePrivacyMode() }}
            data-test="privacy-mode-banner"
        />
    )
}
